import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {BankList, CalculateType, DefaultDropdown, defaultTax, defaultValue, defaultVat, DropdownDatas, hundredPercent, VatLog} from '../../datas';
import { isEmpty, isNumber } from 'lodash';
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import { CalculateService } from 'src/app/core/services/calculate.service';

@Component({
  selector: 'app-calculate-box',
  templateUrl: './calculate-box.component.html',
  styleUrls: ['./calculate-box.component.scss']
})
export class CalculateBoxComponent implements OnInit {

  total: string;
  beforeVat: string;
  calVat: string;
  totalWithVat: string;
  calTax: string;
  totalWithTax: string;
  compareNumber: string;

  form: FormGroup;
  dropdownItems = DropdownDatas;
  selectedItem = DefaultDropdown;
  calType = CalculateType;

  @Output() finishedCalChange = new EventEmitter<any>();

  formClicked = false
  isCollapsed = true

  selectedUserType: any
  userTypeOptions = [
    { value: "receiver", label: "เป็นผู้รับเงิน" },
    { value: "payer", label: "เป็นผู้จ่ายเงิน" },
  ]

  selectedBank: any
  accountName: any
  accountNo: any
  isConsent: any
  
  isUserTypeError: boolean = false
  isAccountNoError: boolean = false

  accountNoLabel: string = ''
  accountNoMaxLength: number = 10

  BankList = BankList

  constructor(
    private calculateService: CalculateService,
  ) { }

  ngOnInit(): void {
    this.total = defaultValue;
    this.form = new FormGroup({
      tax: new FormControl(defaultTax, []),
      vat: new FormControl(defaultVat, [])
    });
  }

  getLocalStoragePrefill(): void {
    this.isConsent = Boolean(localStorage.getItem('v_consent'))
    this.selectedBank = (localStorage.getItem('v_acc_bank') != '') ? localStorage.getItem('v_acc_bank') : null
    this.accountNo = (localStorage.getItem('v_acc_no') != '') ? localStorage.getItem('v_acc_no') : null
    this.accountName = (localStorage.getItem('v_acc_name') != '') ? localStorage.getItem('v_acc_name') : null
    this.setBankInfo()
  }

  saveLocalStorage(): void {
    localStorage.setItem('v_consent', this.isConsent)
    localStorage.setItem('v_acc_bank', this.selectedBank || '')
    localStorage.setItem('v_acc_no', this.accountNo || '')
    localStorage.setItem('v_acc_name', this.accountName || '')
  }

  removeLocalStorage(): void {
    localStorage.removeItem('v_consent')
    localStorage.removeItem('v_acc_bank')
    localStorage.removeItem('v_acc_no')
    localStorage.removeItem('v_acc_name')
  }

  onNumberChange(): void {

  }

  onDdlItemClick(value): void {
    this.selectedItem = value;
  }

  getRawNumberValue(input) {
    let val = input;
    if (!isNumber(input) && !isEmpty(input)) {
      input = parseFloat(input.replace(/(,)/g, ''));
      if (isNaN(input)) {
        val = val.toString();
      } else {
        val = input;
      }
    }
    return val;
  }

  onUserTypeChanged(e: any): void {
    if (e) {
      this.isUserTypeError = false

      if (e == 'receiver') {
        this.getLocalStoragePrefill()
      } else {
        this.isConsent = null
        this.selectedBank = null
        this.accountNo = null
        this.accountName = null
      }
    }
  }

  selectBank(value: any): void {
    this.selectedBank = (this.selectedBank == value) ? null : value
    if (!this.selectedBank) {
      this.accountNo = null
      this.accountName = null
    }
    if (this.isPromptpay()) {
      this.accountName = null
    }
    this.setBankInfo()
  }

  isPromptpay(): boolean {
    return (this.selectedBank == 'promptpay')
  }

  setBankInfo(): void {
    this.accountNoLabel = (this.isPromptpay()) ? 'เบอร์มือถือ' : 'เลขบัญชีธนาคาร'
    this.accountNoMaxLength = BankList.find(o => o.value == this.selectedBank)?.inputLen || 10
  }

  onAccountNoChanged(e: any): void {
    this.isAccountNoError = false
  }

  onConsentChanged(e: any): void {

  }

  checkAccountNo(): void {
    if (this.selectedBank) {
      this.isAccountNoError = (this.accountNo && this.accountNo.length > 0) ? (this.accountNo.length != this.accountNoMaxLength) : false
    } else {
      this.isAccountNoError = false
    }
  }

  submit(): void {
    if (!this.selectedUserType) {
      this.isUserTypeError = true
    }
    this.checkAccountNo()

    if (!this.isUserTypeError && !this.isAccountNoError) {
      this.calculateTax()
    }
  }

  calculateTax(): void {
    const rawVat = this.getRawNumberValue(this.form.value.vat);
    const rawTax = this.getRawNumberValue(this.form.value.tax);
  	const vatValue = isNaN(rawVat) || !rawVat? defaultValue : rawVat;
    const taxValue = isNaN(rawTax) || !rawTax ? defaultValue : rawTax;
    const percentVat = parseFloat(vatValue) / hundredPercent;
    const percentTax = parseFloat(taxValue) / hundredPercent;
    const inputNumber = parseFloat(this.total).toFixed(2);

    const fpPromise = FingerprintJS.load();
    (async () => {
      const fp = await fpPromise
      const result = await fp.get()
      const body: VatLog = {
        visitor_id: result.visitorId,
        user_type: this.selectedUserType,
        input_type: CalculateType[this.selectedItem.id],
        value: parseFloat(this.total),
        vat: vatValue,
        tax: taxValue,
      }

      if (this.selectedUserType == 'receiver') {
        body.consent = this.isConsent
        if (this.isConsent) {
          body.bank = this.selectedBank
          body.account_no = this.accountNo
          body.account_name = this.accountName
          this.saveLocalStorage()
        } else {
          body.bank = (this.selectedBank) ? '**' : null
          body.account_no = (this.accountNo) ? '**' : null
          body.account_name = (this.accountName) ? '**' : null
          this.removeLocalStorage()
        }
      }

      this.calculateService.createVatLog(body).subscribe()

      if (this.selectedItem.id === this.calType.beforeVat) {
        this.beforeVat = inputNumber;
      } else if (this.selectedItem.id === this.calType.withVat) {
        this.beforeVat = (parseFloat(inputNumber) - parseFloat(
          (parseFloat(
            (parseFloat(inputNumber) * parseFloat(vatValue)).toFixed(2)
          ) / (100 + parseFloat(vatValue))).toFixed(2))).toFixed(2);
      } else {
        this.beforeVat = ((parseFloat(inputNumber) * 100) /
          (100 + (parseFloat(vatValue) - parseFloat(taxValue)))).toFixed(2);
        this.calVat = (parseFloat(this.beforeVat) * percentVat).toFixed(2);
      }

      this.calVat = (parseFloat(this.beforeVat) * percentVat).toFixed(2);
      this.totalWithVat = (parseFloat(this.beforeVat) + parseFloat(this.calVat)).toFixed(2);
      this.calTax = (parseFloat(this.beforeVat) * percentTax).toFixed(2);
      this.totalWithTax = (parseFloat(this.beforeVat) + parseFloat(this.calVat) - parseFloat(this.calTax)).toFixed(2);

      if (this.selectedItem.id === this.calType.beforeVat) {
        this.compareNumber = this.beforeVat;
      } else if (this.selectedItem.id === this.calType.withVat) {
        this.compareNumber = this.totalWithVat;
      } else {
        this.compareNumber = this.totalWithTax;
      }

      this.finishedCalChange.emit({
        inputNumber: this.fixNumber(inputNumber),
        compareNumber: this.fixNumber(this.compareNumber),
        vat: vatValue,
        tax: taxValue,
        beforeVat: isNaN(Number(this.beforeVat)) ? defaultValue : this.fixNumber(this.beforeVat),
        calVat: isNaN(Number(this.calVat)) ? defaultValue : this.fixNumber(this.calVat),
        totalWithVat: isNaN(Number(this.totalWithVat)) ? defaultValue : this.fixNumber(this.totalWithVat),
        calTax: isNaN(Number(this.calTax)) ? defaultValue : this.fixNumber(this.calTax),
        totalWithTax: isNaN(Number(this.totalWithTax)) ? defaultValue : this.fixNumber(this.totalWithTax),
        payment: (this.selectedUserType == 'receiver') ? { bank: this.selectedBank, accountNo: this.accountNo, accountName: this.accountName } : null
      });
      document.documentElement.scrollTop = 0;

    })()
  }

  fixNumber(input: string): string {
    return input.includes('.00') ? Intl.NumberFormat('th-TH', {
      style: 'currency',
      currency: 'THB',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(Number(input)) : Intl.NumberFormat('th-TH', {
      style: 'currency',
      currency: 'THB'
    }).format(Number(input));
  }
}
